import React, { FC } from 'react';

import StyledWrap from './styled';

const Wrap: FC<{ paddingTop?: number }> = ({ children, paddingTop }) => (
  <StyledWrap paddingTop={paddingTop}>{children}</StyledWrap>
);

export default Wrap;
